export default __webpack_public_path__ + "static/media/nov2024-3.4e2c604a.jpg";